import { SUCCESS } from '../../../../constants/action-postfix'
import { APPLICANTS_REQUEST, APPLICANT_DELETE_REQUEST } from '../applicantsReducer'

const initialState = []

export const applicantsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${APPLICANTS_REQUEST}${SUCCESS}`:
      return action.payload
    case `${APPLICANT_DELETE_REQUEST}${SUCCESS}`:
      return state.filter(item => item.xp_key !== action.payload)
    default:
      return state
  }
}
